var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgEditAvatarIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.999,
    viewBox: "0 0 18 17.999",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun-edit-1072354",
    transform: "translate(-69.993)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_10178",
    "data-name": "Caminho 10178",
    d: "M81.185,3l3.662,3.679L75.579,16l-3.66-3.678Zm6.44-.888L85.992.476a1.615,1.615,0,0,0-2.289,0L82.139,2.047,85.8,5.727l1.825-1.833a1.259,1.259,0,0,0,0-1.777ZM70,17.49a.418.418,0,0,0,.5.5l4.08-.994-3.66-3.679Z",
    fill: "#c3352d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditAvatarIcon);
export default __webpack_public_path__ + "static/media/edit_avatar_icon.455cfa92890ae296ce9f7ae71148f251.svg";
export { ForwardRef as ReactComponent };